module.exports = require('./helpers/bundle-url').getBundleURL('ljLQj') + "logo-dark.eefe0b7f.svg";